<template>
  <!-- Topbar Start -->
  <div class="topbar-menu">
    <div class="container-fluid">
      <b-collapse id="navigation" v-model="isMenuOpened">
        <!-- Navigation Menu-->
        <ul class="navigation-menu">
          <li>
            <!-- <a href="" @click="goToHome">
              <i class="mdi mdi-airplay"></i>Dashboard
            </a> -->
            <router-link tag="a" to="/home"
              ><i class="mdi mdi-airplay"></i>Dashboard</router-link
            >
          </li>

          <li>
            <router-link tag="a" to="/payment"
              ><i class="mdi mdi-calculator"></i>Payment</router-link
            >
          </li>

          <li
            v-if="
              !noMeteringJobs.includes(
                $store.state.auth.current_account_setup.property_num
              )
            "
          >
            <router-link tag="a" to="/meter"
              ><i class="mdi mdi-gauge"></i>Meter</router-link
            >
          </li>

          <li>
            <router-link tag="a" to="/profile"
              ><i class="mdi mdi-shield-account"></i>Profile</router-link
            >
          </li>

          <!-- <li>
            <router-link tag="a" to="/account-security"
              ><i class="mdi mdi-shield-account"></i>Security</router-link
            >
          </li> -->
          <!-- 
          <li class="has-submenu">
            <a
              href="#"
              @click="onMenuClick"
            >
              <i class="fe-grid"></i>Apps
              <div class="arrow-down"></div>
            </a>
            <ul class="submenu">
              <li class="has-submenu">
                <a
                  href="#"
                  @click="onMenuClick"
                >
                  CRM
                  <div class="arrow-down"></div>
                </a>
                <ul class="submenu">
                  <li>
                    <router-link
                      tag="a"
                      to="/crm/crmdashboard"
                      class="side-nav-link-ref"
                    >Dashboard</router-link>
                  </li>
                  <li>
                    <router-link
                      tag="a"
                      to="/crm/contacts"
                      class="side-nav-link-ref"
                    >Contacts</router-link>
                  </li>
                  <li>
                    <router-link
                      tag="a"
                      to="/crm/opportunities"
                      class="side-nav-link-ref"
                    >Opportunities</router-link>
                  </li>
                  <li>
                    <router-link
                      tag="a"
                      to="/crm/leads"
                      class="side-nav-link-ref"
                    >Leads</router-link>
                  </li>
                  <li>
                    <router-link
                      tag="a"
                      to="/crm/customers"
                      class="side-nav-link-ref"
                    >Customers</router-link>
                  </li>
                </ul>
              </li>
              -->
        </ul>
        <!-- End navigation menu -->

        <div class="clearfix"></div>
      </b-collapse>
      <!-- end #navigation -->
    </div>
    <!-- end container -->
  </div>
  <!-- end navbar-custom -->
</template>

<script>
import { authComputed } from '@store/helpers'

export default {
  components: {},
  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    isMenuOpened: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      // noMeteringJobs: ['ND1001', 'ND1002'],
      noMeteringJobs: [],
    }
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    var links = document.getElementsByClassName('side-nav-link-ref')
    var matchingMenuItem = null
    for (var i = 0; i < links.length; i++) {
      if (window.location.pathname === links[i].pathname) {
        matchingMenuItem = links[i]
        break
      }
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add('active')
      var parent = matchingMenuItem.parentElement

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add('active')
        const parent2 = parent.parentElement
        if (parent2) {
          parent2.classList.add('in')
        }
        const parent3 = parent2.parentElement
        if (parent3) {
          parent3.classList.add('active')
          var childAnchor = parent3.querySelector('.has-dropdown')
          if (childAnchor) childAnchor.classList.add('active')
        }

        const parent4 = parent3.parentElement
        if (parent4) parent4.classList.add('in')
        const parent5 = parent4.parentElement
        if (parent5) parent5.classList.add('active')
      }
    }
  },

  methods: {
    onMenuClick(event) {
      event.preventDefault()
      const nextEl = event.target.nextSibling
      if (nextEl && !nextEl.classList.contains('open')) {
        const parentEl = event.target.parentNode
        if (parentEl) {
          parentEl.classList.remove('open')
        }

        nextEl.classList.add('open')
      } else if (nextEl) {
        nextEl.classList.remove('open')
      }
      return false
    },
    /**
     * Dark Menubar
     */
    darkTopbar() {
      document.body.classList.add('topbar-dark')
      document.body.classList.remove('topbar-light')
      document.body.classList.remove('unsticky-header')
      document.body.classList.remove('boxed-layout')
      document.body.classList.remove('drop-menu-dark')
      document.body.classList.remove('menubar-light')
      document.body.classList.remove('center-menu')
    },

    /**
     * Light Topbar
     */
    lightMenubar() {
      document.body.classList.add('menubar-light')
      document.body.classList.add('topbar-dark')
      document.body.classList.remove('boxed-layout')
      document.body.classList.remove('center-menu')
      document.body.classList.remove('gradient-topbar')
      document.body.classList.remove('unsticky-header')
    },

    /**
     * Show menu in center
     */
    centerMenu() {
      document.body.classList.add('center-menu')
      document.body.classList.remove('topbar-dark')
      document.body.classList.remove('menubar-light')
      document.body.classList.remove('boxed-layout')
      document.body.classList.remove('gradient-topbar')
    },

    gradientTopbar() {
      document.body.classList.add('gradient-topbar')
      document.body.classList.add('topbar-dark')
      document.body.classList.remove('drop-menu-dark')
      document.body.classList.remove('unsticky-header')
      document.body.classList.remove('center-menu')
    },

    dropmenuDark() {
      document.body.classList.add('drop-menu-dark')
      document.body.classList.remove('gradient-topbar')
      document.body.classList.remove('boxed-layout')
      document.body.classList.remove('center-menu')
      document.body.classList.remove('menubar-light')
    },
    /**
     * Unsticky Header
     */
    unstickyHeader() {
      document.body.classList.add('unsticky-header')
      document.body.classList.remove('boxed-layout')
      document.body.classList.remove('center-menu')
      document.body.classList.remove('drop-menu-dark')
      document.body.classList.remove('topbar-dark')
      document.body.classList.remove('menubar-light')
    },

    /**
     * Boxed Layout
     */
    boxedLayout() {
      document.body.classList.add('boxed-layout')
      document.body.classList.remove('drop-menu-dark')
      document.body.classList.remove('gradient-topbar')
      document.body.classList.remove('topbar-dark')
      document.body.classList.remove('menubar-light')
    },
    // goToHome() {
    //   this.$router.push('home')
    // },
    // goToPayment() {
    //   this.$router.push('payment')
    // },
    // goToMetering() {
    //   this.$router.push('metering')
    // },
    // goToProfile() {
    //   this.$router.push('profile')
    // },
  },
}
</script>
